import {
  DAY_CLASS_NAME,
  DAYS_DOMAIN,
  EXERCISES_DOMAIN,
  MEDIA_DOMAIN,
  MEDIA_MODEL_CLASS_NAME,
  PROFILES_DOMAIN,
  REPORT_CLASS_NAME,
  WORKOUT_CLASS_NAME,
  WORKOUT_EXERCISE_CLASS_NAME,
  WORKOUT_EXERCISES_DOMAIN,
  WORKOUT_SECTION_CLASS_NAME,
  WORKOUT_SECTIONS_DOMAIN
} from '@gymaholic/packages'
import { ADDRESS_MODEL_CLASS_NAME } from 'models/daos/address/constants'
import { ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import { CARD_MODEL_CLASS_NAME } from 'models/daos/card/constants'
import { CART_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/cart-product/constants'
import { CART_MODEL_CLASS_NAME } from 'models/daos/cart/constants'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { CREDENTIAL_CLASS_NAME } from 'models/daos/credential/constants'
import {
  CURRENCY_MODEL_CLASS_NAME,
  CURRENCY_MODEL_KEY
} from 'models/daos/currency/constants'
import { EMAIL_TEMPLATE_MODEL_CLASS_NAME } from 'models/daos/email-template/constants'
import { LOG_MODEL_CLASS_NAME } from 'models/daos/log/constants'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { NOTIFICATION_MODEL_CLASS_NAME } from 'models/daos/notification/constants'
import { ORDER_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/order-product/constants'
import { ORDER_MODEL_CLASS_NAME } from 'models/daos/order/constants/index.cjs'
import { PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { PRODUCT_QUANTITY_MODEL_CLASS_NAME } from 'models/daos/product-quantity/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { SECTION_MODEL_CLASS_NAME } from 'models/daos/section/constants/index.cjs'
import { SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'
import {
  SHIPPING_MODEL_CLASS_NAME,
  SHIPPING_MODEL_KEY
} from 'models/daos/shipping/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'
import { TOKEN_MODEL_CLASS_NAME } from 'models/daos/token/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { ABOUTS_DOMAIN } from 'modules/abouts/constants'
import { ADDRESS_DOMAIN } from 'modules/address/constants'
import { APP_DOMAIN } from 'modules/app/constants'
import {
  ARTICLES_DOMAIN,
  ARTICLES_DOMAIN_MAP_KEY
} from 'modules/articles/constants'
import { CARDS_DOMAIN } from 'modules/cards/constants'
import { CART_PRODUCTS_DOMAIN } from 'modules/cart-products/constants'
import { CART_DOMAIN } from 'modules/cart/constants'
import {
  CATEGORIES_DOMAIN,
  CATEGORIES_DOMAIN_MAP_KEY
} from 'modules/categories/constants'
import {
  COMMENTS_DOMAIN,
  COMMENTS_DOMAIN_MAP_KEY
} from 'modules/comments/constants'
import { CREDENTIAL_DOMAIN } from 'modules/credential/constants'
import {
  CURRENCIES_DOMAIN,
  CURRENCIES_DOMAIN_MAP_KEY
} from 'modules/currencies/constants'
import { EDITING_DOMAIN } from 'modules/editing/constants'
import { EMAIL_TEMPLATES_DOMAIN } from 'modules/email-templates/constants'
import { FEATURED_DOMAIN } from 'modules/featured/constants'
import {
  LOGS_DOMAIN,
  LOGS_DOMAIN_MAP_KEY
} from 'modules/logs/constants'
import { MENU_DOMAIN } from 'modules/menu/constants'
import { MODAL_DOMAIN } from 'modules/modal/constants/index.cjs'
import {
  MOTIVATION_DOMAIN,
  MOTIVATION_DOMAIN_MAP_KEY
} from 'modules/motivation/constants'
import { NETWORK_DOMAIN } from 'modules/network/constants'
import {
  NOTIFICATIONS_DOMAIN,
  NOTIFICATIONS_DOMAIN_MAP_KEY
} from 'modules/notifications/constants'
import { ORDER_PRODUCTS_DOMAIN } from 'modules/order-products/constants'
import {
  ORDERS_DOMAIN,
  ORDERS_DOMAIN_MAP_KEY
} from 'modules/orders/constants/index.cjs'
import {
  PAGES_DOMAIN,
  PAGES_DOMAIN_MAP_KEY
} from 'modules/pages/constants'
import { PARSER_DOMAIN } from 'modules/parser/constants'
import { PRODUCT_QUANTITIES_DOMAIN } from 'modules/product-quantities/constants'
import {
  PRODUCTS_DOMAIN,
  PRODUCTS_DOMAIN_MAP_KEY
} from 'modules/products/constants'
import {
  PROMO_CODES_DOMAIN,
  PROMO_CODES_DOMAIN_MAP_KEY
} from 'modules/promo-codes/constants'
import { MODEL_KEY } from 'modules/redux/constants/model-key'
import { REPORTS_DOMAIN } from 'modules/reports/constants'
import { SEARCH_DOMAIN } from 'modules/search/constants'
import {
  SECTIONS_DOMAIN,
  SECTIONS_DOMAIN_MAP_KEY,
  SECTIONS_NAME
} from 'modules/sections/constants/index.cjs'
import {
  SETTINGS_DOMAIN,
  SETTINGS_DOMAIN_MAP_KEY
} from 'modules/settings/constants'
import {
  SHIPPING_DOMAIN,
  SHIPPING_DOMAIN_MAP_KEY
} from 'modules/shipping/constants'
import {
  TAGS_DOMAIN,
  TAGS_DOMAIN_MAP_KEY
} from 'modules/tags/constants'
import {
  TOKENS_DOMAIN,
  TOKENS_DOMAIN_MAP_KEY
} from 'modules/tokens/constants'
import { ABOUT_MODEL_CLASS_NAME } from 'modules/training/models/abouts/constants'
import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'
import { TRAINING_PLAN_CLASS_NAME } from 'modules/training/models/plan/constants'
import { PREFERENCES_MODEL_CLASS_NAME } from 'modules/training/models/preferences/constants'
import { PROFILE_CREATOR_PREFERENCE_MODEL_CLASS_NAME } from 'modules/training/models/profile-creator-preferences/constants'
import { TRAINING_PROFILE_CLASS_NAME } from 'modules/training/models/profile/constants'
import {
  CUSTOMER_CLASS_NAME,
  CUSTOMERS_DOMAIN
} from 'modules/training/modules/customer/constants'
import { PREFERENCES_DOMAIN } from 'modules/training/modules/preferences/constants'
import { PROFILE_CREATOR_PREFERENCES_DOMAIN } from 'modules/training/modules/profile-creator-preferences/constants'
import { PLANS_DOMAIN } from 'modules/plan/redux/constants'
import { TRAINING_USERS_DOMAIN } from 'modules/training/modules/training-users/constants'
import { WORKOUTS_DOMAIN } from 'modules/workout/redux/constants'
import {
  USERS_DOMAIN,
  USERS_DOMAIN_MAP_KEY
} from 'modules/users/constants'
import { VIEWS_DOMAIN } from 'modules/views/constants'
import {
  SUBSCRIPTION_CLASS_NAME,
  SUBSCRIPTIONS_DOMAIN
} from 'modules/training/modules/subscription/constants'
import { invertObjectUtil } from 'packages/src'

/**
 * Domain names.
 * @type {Object}
 */
const REDUX_DOMAIN = {
  ADDRESS: ADDRESS_DOMAIN,
  ARTICLES: ARTICLES_DOMAIN,
  CARDS: CARDS_DOMAIN,
  CART: CART_DOMAIN,
  CART_PRODUCTS: CART_PRODUCTS_DOMAIN,
  CATEGORIES: CATEGORIES_DOMAIN,
  COMMENTS: COMMENTS_DOMAIN,
  CREDENTIAL: CREDENTIAL_DOMAIN,
  CURRENCIES: CURRENCIES_DOMAIN,
  EDITING: EDITING_DOMAIN,
  EMAIL_TEMPLATES: EMAIL_TEMPLATES_DOMAIN,
  FEATURED: FEATURED_DOMAIN,
  LOGS: LOGS_DOMAIN,
  MENU: MENU_DOMAIN,
  MODAL: MODAL_DOMAIN,
  MOTIVATION: MOTIVATION_DOMAIN,
  NETWORK: NETWORK_DOMAIN,
  NOTIFICATIONS: NOTIFICATIONS_DOMAIN,
  ORDERS: ORDERS_DOMAIN,
  PAGES: PAGES_DOMAIN,
  PARSER: PARSER_DOMAIN,
  PRODUCT_QUANTITIES: PRODUCT_QUANTITIES_DOMAIN,
  PRODUCTS: PRODUCTS_DOMAIN,
  PROMO_CODES: PROMO_CODES_DOMAIN,
  REPORTS: REPORTS_DOMAIN,
  SEARCH: SEARCH_DOMAIN,
  SECTIONS: SECTIONS_DOMAIN,
  SETTINGS: SETTINGS_DOMAIN,
  SHIPPING: SHIPPING_DOMAIN,
  TAGS: TAGS_DOMAIN,
  TOKENS: TOKENS_DOMAIN,
  USERS: USERS_DOMAIN,
  VIEWS: VIEWS_DOMAIN,
  APP: APP_DOMAIN,
  ORDER_PRODUCTS: ORDER_PRODUCTS_DOMAIN
}

/**
 * A mapping of className to domain.
 * @type {Object}
 */
const REDUX_CLASS_NAME_TO_DOMAIN = {
  [ADDRESS_MODEL_CLASS_NAME]: REDUX_DOMAIN.ADDRESS,
  [ARTICLE_MODEL_CLASS_NAME]: REDUX_DOMAIN.ARTICLES,
  [CARD_MODEL_CLASS_NAME]: REDUX_DOMAIN.CARDS,
  [CART_MODEL_CLASS_NAME]: REDUX_DOMAIN.CART,
  [CART_PRODUCT_MODEL_CLASS_NAME]: REDUX_DOMAIN.CART_PRODUCTS,
  [CATEGORY_MODEL_CLASS_NAME]: REDUX_DOMAIN.CATEGORIES,
  [CREDENTIAL_CLASS_NAME]: REDUX_DOMAIN.CREDENTIAL,
  [COMMENT_MODEL_CLASS_NAME]: REDUX_DOMAIN.COMMENTS,
  [CURRENCY_MODEL_CLASS_NAME]: REDUX_DOMAIN.CURRENCIES,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: REDUX_DOMAIN.EMAIL_TEMPLATES,
  [LOG_MODEL_CLASS_NAME]: REDUX_DOMAIN.LOGS,
  [PAGE_MODEL_CLASS_NAME]: REDUX_DOMAIN.PAGES,
  [MOTIVATION_MODEL_CLASS_NAME]: REDUX_DOMAIN.MOTIVATION,
  [NOTIFICATION_MODEL_CLASS_NAME]: REDUX_DOMAIN.NOTIFICATIONS,
  [ORDER_MODEL_CLASS_NAME]: REDUX_DOMAIN.ORDERS,
  [ORDER_PRODUCT_MODEL_CLASS_NAME]: REDUX_DOMAIN.ORDER_PRODUCTS,
  [PROMO_CODE_MODEL_CLASS_NAME]: REDUX_DOMAIN.PROMO_CODES,
  [PRODUCT_MODEL_CLASS_NAME]: REDUX_DOMAIN.PRODUCTS,
  [PRODUCT_QUANTITY_MODEL_CLASS_NAME]: REDUX_DOMAIN.PRODUCT_QUANTITIES,
  // [REPORT_MODEL_CLASS_NAME]: REDUX_DOMAIN.REPORTS,
  [SETTINGS_MODEL_CLASS_NAME]: REDUX_DOMAIN.SETTINGS,
  [SHIPPING_MODEL_CLASS_NAME]: REDUX_DOMAIN.SHIPPING,
  [SECTION_MODEL_CLASS_NAME]: REDUX_DOMAIN.SECTIONS,
  [TAG_MODEL_CLASS_NAME]: REDUX_DOMAIN.TAGS,
  [TOKEN_MODEL_CLASS_NAME]: REDUX_DOMAIN.TOKENS,
  [USER_MODEL_CLASS_NAME]: REDUX_DOMAIN.USERS,
  // Training
  [ABOUT_MODEL_CLASS_NAME]: ABOUTS_DOMAIN,
  [CUSTOMER_CLASS_NAME]: CUSTOMERS_DOMAIN,
  [DAY_CLASS_NAME]: DAYS_DOMAIN,
  [EXERCISE_CLASS_NAME]: EXERCISES_DOMAIN,
  [MEDIA_MODEL_CLASS_NAME]: MEDIA_DOMAIN,
  [REPORT_CLASS_NAME]: REPORTS_DOMAIN,
  [PREFERENCES_MODEL_CLASS_NAME]: PREFERENCES_DOMAIN,
  [PROFILE_CREATOR_PREFERENCE_MODEL_CLASS_NAME]: PROFILE_CREATOR_PREFERENCES_DOMAIN,
  [SUBSCRIPTION_CLASS_NAME]: SUBSCRIPTIONS_DOMAIN,
  [TRAINING_PLAN_CLASS_NAME]: PLANS_DOMAIN,
  [TRAINING_PROFILE_CLASS_NAME]: PROFILES_DOMAIN,
  [WORKOUT_CLASS_NAME]: WORKOUTS_DOMAIN,
  [WORKOUT_SECTION_CLASS_NAME]: WORKOUT_SECTIONS_DOMAIN,
  [WORKOUT_EXERCISE_CLASS_NAME]: WORKOUT_EXERCISES_DOMAIN
}

/**
 * A mapping of Domain name to className.
 * @type {Object}
 */
const REDUX_DOMAIN_TO_CLASS_NAME = invertObjectUtil(REDUX_CLASS_NAME_TO_DOMAIN)

/**
 * A mapping of section to domain.
 * @type {Object}
 */
const REDUX_SECTION_TO_DOMAIN = {
  [SECTIONS_NAME.HOME]: REDUX_DOMAIN.CATEGORIES,
  [SECTIONS_NAME.ADDRESS]: REDUX_DOMAIN.ADDRESS,
  [SECTIONS_NAME.ARTICLES]: REDUX_DOMAIN.ARTICLES,
  [SECTIONS_NAME.COMMENTS]: REDUX_DOMAIN.COMMENTS,
  [SECTIONS_NAME.EMAIL_TEMPLATES]: REDUX_DOMAIN.EMAIL_TEMPLATES,
  [SECTIONS_NAME.MOTIVATION]: REDUX_DOMAIN.MOTIVATION,
  [SECTIONS_NAME.LOGS]: REDUX_DOMAIN.LOGS,
  [SECTIONS_NAME.NOTIFICATIONS]: REDUX_DOMAIN.NOTIFICATIONS,
  [SECTIONS_NAME.ORDERS]: REDUX_DOMAIN.ORDERS,
  [SECTIONS_NAME.PROFILE]: REDUX_DOMAIN.USERS,
  [SECTIONS_NAME.PAGES]: REDUX_DOMAIN.PAGES,
  [SECTIONS_NAME.PROMO_CODES]: REDUX_DOMAIN.PROMO_CODES,
  [SECTIONS_NAME.REPORTS]: REDUX_DOMAIN.REPORTS,
  [SECTIONS_NAME.SEARCH]: REDUX_DOMAIN.SEARCH,
  [SECTIONS_NAME.SETTINGS]: REDUX_DOMAIN.SETTINGS,
  [SECTIONS_NAME.EXERCISES]: EXERCISES_DOMAIN,
  [SECTIONS_NAME.STORE]: REDUX_DOMAIN.PRODUCTS,
  [SECTIONS_NAME.TOKENS]: REDUX_DOMAIN.TOKENS,
  [SECTIONS_NAME.USERS]: REDUX_DOMAIN.USERS
}

/**
 * Mapping of domain to map key.
 *
 * @example
 *
 * ```js
 * const STORE = {
 *
 *  articles : {
 *    data : {
 *      [slug] : obj,
 *    }
 *  },
 *
 *  users : {
 *    data : {
 *      [name] : obj,
 *    }
 *  },
 *
 *
 * }
 * ```
 *
 * @type {Object}
 */
const REDUX_DEFAULT_DOMAIN_MAP_KEY = 'id'
const REDUX_DOMAIN_MAP_KEY = {
  [REDUX_DOMAIN.ARTICLES]: ARTICLES_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.CATEGORIES]: CATEGORIES_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.COMMENTS]: COMMENTS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.CURRENCIES]: CURRENCIES_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.LOGS]: LOGS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.MOTIVATION]: MOTIVATION_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.NOTIFICATIONS]: NOTIFICATIONS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.ORDERS]: ORDERS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.PAGES]: PAGES_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.PROMO_CODES]: PROMO_CODES_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.PRODUCTS]: PRODUCTS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.SECTIONS]: SECTIONS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.SETTINGS]: SETTINGS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.SHIPPING]: SHIPPING_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.TAGS]: TAGS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.TOKENS]: TOKENS_DOMAIN_MAP_KEY,
  [REDUX_DOMAIN.USERS]: USERS_DOMAIN_MAP_KEY,
  // Training
  [EXERCISES_DOMAIN]: REDUX_DEFAULT_DOMAIN_MAP_KEY,
  [TRAINING_USERS_DOMAIN]: REDUX_DEFAULT_DOMAIN_MAP_KEY,
  [PROFILES_DOMAIN]: REDUX_DEFAULT_DOMAIN_MAP_KEY,
  [PLANS_DOMAIN]: REDUX_DEFAULT_DOMAIN_MAP_KEY,
  [WORKOUTS_DOMAIN]: REDUX_DEFAULT_DOMAIN_MAP_KEY
}

/**
 * The default key where the instances are listed by `domainMapKey` @see above.
 *
 * @example
 *
 * ```js
 * const STORE = {
 *  articles : {
 *    data : {
 *      [article.id] : article,
 *    },
 *    [REDUX_DEFAULT_DOMAIN_LIST_KEY] : [article.id]
 *  }
 * }
 * ```
 *
 * @type {string}
 */
const REDUX_DEFAULT_DOMAIN_LIST_KEY = 'all'

const REDUX_DOMAIN_ALIAS_KEY = 'alias'

/**
 * Sort of order.
 * @type {Object}
 */
const REDUX_ORDER = {
  ASC: 'asc',
  DESC: 'desc'
}

/**
 * The default sort order.
 * @type {string}
 */
const REDUX_DEFAULT_ORDER = REDUX_ORDER.DESC
/**
 * A mapping of className to sortKey.
 * @type {Object}
 */
const REDUX_CLASS_NAME_TO_ORDER = {
  [EXERCISE_CLASS_NAME]: REDUX_ORDER.ASC,
  [CURRENCY_MODEL_CLASS_NAME]: REDUX_ORDER.ASC,
  [SHIPPING_MODEL_CLASS_NAME]: REDUX_ORDER.ASC,
  [COMMENT_MODEL_CLASS_NAME]: REDUX_ORDER.DESC
}

/**
 * A mapping of className to sortKey.
 * @type {Object}
 */
const REDUX_CLASS_NAME_TO_SORT_KEY = {
  [ARTICLE_MODEL_CLASS_NAME]: MODEL_KEY.CREATED_AT,
  [CURRENCY_MODEL_CLASS_NAME]: CURRENCY_MODEL_KEY.NAME,
  [EXERCISE_CLASS_NAME]: 'name',
  [SHIPPING_MODEL_CLASS_NAME]: SHIPPING_MODEL_KEY.PRICE
}

/**
 * The default key used for sorting.
 * @type {string}
 */
const REDUX_DEFAULT_SORT_KEY = 'id'

export {
  REDUX_CLASS_NAME_TO_DOMAIN,
  REDUX_DEFAULT_DOMAIN_MAP_KEY,
  REDUX_DOMAIN,
  REDUX_DOMAIN_MAP_KEY,
  REDUX_DOMAIN_TO_CLASS_NAME,
  REDUX_SECTION_TO_DOMAIN,
  REDUX_DEFAULT_DOMAIN_LIST_KEY,
  REDUX_DOMAIN_ALIAS_KEY,
  REDUX_ORDER,
  REDUX_CLASS_NAME_TO_ORDER,
  REDUX_DEFAULT_ORDER,
  REDUX_CLASS_NAME_TO_SORT_KEY,
  REDUX_DEFAULT_SORT_KEY
}
